<template>
	<div id="createMapEditor" :class="{inactive : widthStyle}">
       
            <div class="next-block-buttons col md-6" v-if="canEditAndInteract">
                
                <div class="complete-area">
                    <button class="primary" @click="openCompleteAreaModal">
                        Continue
                    </button>
                </div>
                <div class="cancel-area">
                    <a @click="resetPolygonArea">
                        Cancel
                    </a>
                </div>
                <div class="pwer-by-logo-watermark-mob"  v-if="maContent.maO_2 == true">
					<a href="https://mapitapp.co.uk/" target="_blank"><img src="@/assets/images/Powered-by-MapitApp-white.svg" style="max-width:160px"></a>
				</div>
            </div>

            <!-- <div class="pwer-by-logo-watermark">
					<a href="https://mapitapp.co.uk/" target="_blank"><img src="@/assets/images/MapitApp-logo-blue.svg" style="max-width:160px"></a>
				</div> -->
            <div class="map-editor-search" v-if="canEditAndInteract">
                <div class="map-editor__wrap">
                    <div class="map-editor-search__subhead">{{maContent.ma3_1}}</div>
                    <div class="map-editor-search__button"></div>
                    <gmap-autocomplete
                        onfocus="this.value = ''" 
                        placeholder ="Enter City, Town, Postcode.." 
                        :value="description" 
                        :defaultPlace="mapSearchInput"
                        :selectFirstOnEnter="true"
                        ref="autoCompleter"
                        @place_changed="setPlace">
                    </gmap-autocomplete>
                </div>
            </div>
    		<gmap-map 
    			ref="mapRef" 
    			:center="mapData.center"
    			:zoom="mapData.zoom"
                :options="{
                	scrollwheel: canEditAndInteract,
                    zoomControl: canEditAndInteract,
                    customZoomControl: true,
                    zoomControlOptions: {
                        position: 9
                        },
                    mapTypeControl: mapData.canEditAndInteract,
                    mapTypeControlOptions: {
                        position: 7,
                    },
                    mapTypeId: mapStyle,
                    scaleControl: mapData.scaleControl,
                    draggable : canEditAndInteract,
                    rotateControl: mapData.rotateControl,                    
                    streetViewControl: mapData.streetViewControl,
                    fullscreenControl: mapData.fullscreenControl,
                    maxZoom : mapData.maxZoom,
                    tilt:0,                    
                    }"
    			style="width: 100%; height: 100%;"
                >
                
                <div v-if="reviewAreaPanelActive">
                    <gmap-cluster v-if="shouldUseMarkers == true">
                         <gmap-marker  v-for="(m, i) in markers"
                            :key="i + 'a'" 
                            :position="m.position" 
                            :animation="4"
                            :icon="mapIcon"
                           >
                        </gmap-marker>
                    </gmap-cluster>
                    <gmap-polygon v-else
                        v-for="(poly, i) in savedAreasPolygonData" 
                        :paths="poly" 
                        :key="i + 'b'" 
                        :editable="canEditPolygon"
                        :options="{
                           fillColor: '#5386ff00',
        	  			   strokeOpacity: 0.8,
        	               strokeWeight: 3,
        	               strokeColor: '#E51D2A'
                         }"
                        ref="polygon" 
                    >
                    </gmap-polygon>
                    
         </gmap-polyline>
                </div>

                <div v-if="!reviewAreaPanelActive">
                    <gmap-cluster v-if="shouldUseMarkers == true">
                         <gmap-marker  v-for="(m, i) in markers"
                            :key="i + 'c'" 
                            :position="m.position" 
                            :animation="4"
                            :icon="mapIcon"
                           >
                        </gmap-marker>
                    </gmap-cluster>
                    <gmap-polygon v-else
                        v-for="(poly, i) in savedAreasPolygonData" 
                        :paths="poly" 
                        :key="i + 'd'" 
                        :editable="false"
                        :options="{
                           fillColor: '#5386ff00',
        	  			   strokeOpacity: 0.8,
        	               strokeWeight: 3,
        	               strokeColor: '#E51D2A'
                         }"
                        ref="polygon" 
                    >
                    </gmap-polygon>
        	        <gmap-polygon 

        	        	v-for="(poly, i) in mapData.polygonsList" 
        	        	:paths="poly" 
        	        	:key="i + 'e'" 
        	        	:editable="canEditPolygon"
        				:options="{
        	               fillColor: '#5386ff00',
        	  			   strokeOpacity: 0.8,
        	               strokeWeight: 3,
        	               strokeColor: '#E51D2A'
        	             }"
        	            ref="polygon"
                        @rightclick="deleteVertex"
        	            @paths_changed="updateEdited($event)"
        	        >
        	        </gmap-polygon>
                </div>
    	    </gmap-map>
       
	</div>
</template>

<script>
    
    import mapicon from '@/assets/images/map-icon-blue.png';
	export default {
        props : ['canDraw','queryPcode','widthStyle','canEditPolygon', 'canEditAndInteract', 'reviewAreaPanelActive', 'detailsAreaPanelActive'],
		data() {
  
            return {
                mapSearchInput : '',
                description : '',
                shouldUseMarkers : false,
                markers : [],
                mapIcon : mapicon,
                rotateControl: false,
                mapStyle : 'roadmap',
            }
        },
        watch : {
            savedAreasPolygonData : {
                handler : function(){
                    this.addMarkers();
                    this.triggerResize();
                },
                deep: true
            },
            canDraw : function(newVal, oldVal){
                this.setDrawingMode(newVal);
            },
            queryPcode : function(newVal, oldVal){
                if(newVal){
                    this.description = newVal
                    this.mapSearchInput = newVal;
                    this.codeAddress(newVal)
                }
            }
        },
        
        computed : {
            mapData(){
                return this.$store.getters.mapData;
            },
            savedAreas(){
                return this.$store.getters.savedAreas;
            },
            
            savedAreasPolygonData(){
                let vm = this;
                let polydata = this.savedAreas.map(function(area){
                    return JSON.parse(area.kmlCoordinates);
                })
                return polydata;
            },
            totalArea(){
				let areas = this.savedAreas

				if(areas.length == 0){
					return;
				}

				let reducedObj = areas.reduce(function (a, b) {
				  return {areaSquared: a.areaSquared + b.areaSquared}; // returns object with property x
				})

                //return reducedObj.areaSquared;
                return reducedObj.areaSquared.toLocaleString('en')
			},
            maContent(){
      			return this.$store.getters.getBuildData;
    		}
        },
        methods: {
            codeAddress(address) {
                let vm = this;
                vm.$refs.mapRef.$mapPromise.then(() => {
                    let geocoder = new google.maps.Geocoder();
                    geocoder.geocode( { 'address': address}, function(results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {

                            vm.setPlace(results[0])
                       
                        } else {
                             vm.$toasted.error('Invalid Address, try enter a location', {
                                theme: 'bubble',
                                position: 'bottom-center',
                                duration: 5000
                            })
                        }
                    });
                 });
            },
            addMarkers(){
                this.markers = this.savedAreasPolygonData.map((area) => {
                    return {position : area[1], icon : this.mapIcon}
                })
            },
            setPlace(place) {
                this.mapData.center = {
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng(),

                };
                this.mapData.zoom = 19;
                this.mapData.mapTypeId = 'hybrid';
            },
            triggerResize(){
                let vm = this;
                 vm.$refs.mapRef.$mapPromise.then(() => {
                    google.maps.event.trigger(vm.$refs.mapRef.$mapObject, 'resize')
                 });
            },
            triggerBounds(){
                let vm = this;
                 vm.$refs.mapRef.$mapPromise.then(() => {
                    google.maps.event.trigger(vm.$refs.mapRef.$mapObject, 'bounds_changed')
                    });
            },
            createPolygon(latlngArr){
                let vm = this;
                let polygon = [];
                latlngArr.forEach(function (position) {
                    polygon.push({
                        lat: position.lat(),
                        lng: position.lng()
                    })
               });
               this.$store.commit('createPolygon', [polygon])
            },
            resetPolygonArea(){
                let vm = this;
                vm.$refs.mapRef.$mapPromise.then(() => {
                    this.$store.commit('removePolygon');
                    vm.setDrawingMode('polygon');
                });
            },
            initDrawingTools(){
                const vm = this;

                vm.$refs.mapRef.$mapPromise.then(() => {
                    const drawingManager = new google.maps.drawing.DrawingManager({
                        drawingControl: false,
                        drawingControlOptions: {
                            position: google.maps.ControlPosition.TOP_CENTER,
                            drawingModes: [google.maps.drawing.OverlayType.POLYGON]
                        },
                        polygonOptions: {
                            fillColor: '#5386ff00',
        	  			    strokeOpacity: 0.8,
        	                strokeWeight: 3,
        	                strokeColor: '#E51D2A',
                            editable: true
                        }
                    });
                    drawingManager.setMap(this.$refs.mapRef.$mapObject);
                    vm.drawingManager = drawingManager;
                });
            },
            setDrawingMode(polygonOrNull){
                let vm = this;
                 vm.$refs.mapRef.$mapPromise.then(() => {
                    vm.drawingManager.setDrawingMode(polygonOrNull);
                });
            },
            updateEdited(mvcArray) {
                let paths = [];
                for (let i = 0; i < mvcArray.getLength(); i++) {
                    let path = [];
                    for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
                        let point = mvcArray.getAt(i).getAt(j);
                        path.push({lat: point.lat(), lng: point.lng()});
                    }
                    paths.push(path);
                }
                this.$store.commit('createPolygon', paths)
                let areaArr = this.$refs.polygon[0].paths.map(( set ) => {
                    return {lat : () => {return set.lat }, lng : () => {return set.lng }};
                })
                let totalArea = Math.round(google.maps.geometry.spherical.computeArea(areaArr));
                this.$store.commit('areaCreator', {areaSquared : totalArea})
            },
            deleteVertex(e){
                let vm = this;
                let find = {lat : e.latLng.lat(),lng : e.latLng.lng()}
                let vertexPosition = this.mapData.polygonsList[0].findIndex((vertex) => {
                    return vertex.lat === find.lat && vertex.lng === find.lng
                })
                if(vertexPosition == -1){
                    return;
                }
                this.$store.commit('deleteVertex', vertexPosition)
                if(this.mapData.polygonsList[0].length == 0){
                    vm.setDrawingMode('polygon');
                }
            },
            drawingManagerEvents(){
                let vm = this;
                vm.$refs.mapRef.$mapPromise.then(() => {
                    let drawingManager = vm.drawingManager;
                    google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                            let paths = event.overlay.getPath().getArray();
                            event.overlay.setMap(null);
                            let totalArea = Math.round(google.maps.geometry.spherical.computeArea(paths));
                            vm.$store.commit('areaCreator', {areaSquared : totalArea})
                            vm.setDrawingMode(this.canDraw);
                            vm.createPolygon(paths);
                        }
                      
                    );
                    
                    google.maps.event.addListener(vm.$refs.mapRef.$mapObject, 'resize', 
                        function(event){
                            var bounds = new google.maps.LatLngBounds();
                            var i;
                            if(vm.reviewAreaPanelActive){
                                for (i = 0; i < vm.savedAreasPolygonData.length; i++) {
                                  for(let x = 0; x < vm.savedAreasPolygonData[i].length; x++){
                                    bounds.extend(vm.savedAreasPolygonData[i][x]);
                                  }
                                }     
                                let newCenter = {
                                    lat : bounds.getCenter().lat(),
                                    lng : bounds.getCenter().lng()
                                }
                                vm.$store.commit('updateMapCenter', newCenter);
                                vm.$refs.mapRef.$mapObject.fitBounds(bounds);  
                                return;
                            }
                            if(vm.detailsAreaPanelActive && vm.mapData.polygonsList[0]) {
                                for (i = 0; i < vm.mapData.polygonsList[0].length; i++) {
                                  bounds.extend(vm.mapData.polygonsList[0][i]);
                                }     
                                let newCenter = {
                                    lat : bounds.getCenter().lat(),
                                    lng : bounds.getCenter().lng()
                                }
                                vm.$store.commit('updateMapCenter', newCenter);
                                vm.$refs.mapRef.$mapObject.fitBounds(bounds);
                            }
                        }
                    );
                    google.maps.event.addListener(vm.$refs.mapRef.$mapObject, 'bounds_changed', function(event){
                        let mapObj = vm.$refs.mapRef.$mapObject;
                        let zoom = mapObj.getZoom();
                            if(zoom >= 12){
                                vm.shouldUseMarkers = false;
                                vm.mapStyle = 'satellite';
                            } else {
                                vm.shouldUseMarkers = true;
                                vm.mapStyle = 'roadmap';
                            }
                        
                    })
                });
            },
            clearSearchBox(){
                alert('test');
            },
            openCompleteAreaModal(){
                if(!this.mapData.polygonsList[0]){
                    this.$toasted.error('Please create an area on the map first', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
                    return
                }
                this.$store.commit('areaCreator', {kmlCoordinates : this.mapData.polygonsList[0]})
                this.$store.commit('openModal', 'TitleDescModal')
                this.triggerResize();
            }
        },
        mounted(){
            let vm = this;
       
            vm.initDrawingTools();
            vm.drawingManagerEvents();
            vm.setDrawingMode(vm.canDraw);
            vm.addMarkers();
            if(vm.reviewAreaPanelActive){
                
            }
            vm.triggerResize();

        },


	}
</script>


// WEBPACK FOOTER //
// src/components/common/Create/CreateMapEditor.vue